<template>
  <div class="workspace">
    <add-restaurant-sales-popup :is-sidebar-active="specialPopup" :data-prop="popupData" :end="popupEnded" @closeSidebar="popupEnded" />
    <div class="section-heading">
      <h2>Restaurant Sales</h2>
    </div>
    <div class="spc-cont user-search-section">
      <div @click="showPopup" class="tr-button blue-button"><i class="fas fa-plus"></i> Add New Restaurant</div>
      <div class="user-search-bar ml-6">
        <input class="tr-input" type="text" v-model="searchString" placeholder="Search content..."/>
        <span class="text-danger text-sm ml-4" v-show="searchString !== '' && !searchedProducts.length > 0">No result</span>
      </div>
      <div class="user-search-button">
        <div class="tr-button blue-button" @click="searchProducts">Search</div>
      </div>
    </div>
    <div id="menu-category" class="menu-list products">
      <div class="menu-list-item heading">
        <div class="menu-list-item-column">Name</div>
        <div class="menu-list-item-column">Description</div>
        <div class="menu-list-item-column">Actions</div>
      </div>
      <div v-for="content in displayList" :key="content.id" class="menu-list-item">
        <div class="menu-list-item-column">{{ content.name }}</div>
        <div class="menu-list-item-column">{{ content.description.length > 100 ? `${content.body.substring(0, 100)}...` : content.description }}</div>
        <div class="menu-list-item-column">
          <div @click="editData(content)" class="list-button"><i class="fas fa-edit"></i>Edit</div>
          <div @click.stop="confirmDelete(content.id)" class="list-button"><i class="fas fa-trash"></i>Delete</div>

        </div>
      </div>
    </div>
    <div class="pagination flex" v-if="displayListSource.length > itemCount">
      <div @click="pageDown">&laquo;</div>
      <div class="cursor-pointer" @click="pageCount = page - 1" v-for="(page, index) in pageArray" :key="index" :class="page === pageCount + 1 ? 'active' : ''">{{page}}</div>
      <div @click="pageUp">&raquo;</div>
    </div>
    <div>
  </div>
  </div>
</template>

<script>
import AddRestaurantSalesPopup from './AddRestaurantSalesPopup'
export default {
  name: 'Specials',
  components: {
    AddRestaurantSalesPopup
  },
  data () {
    return {
      specialPopup: false,
      popupData: null,
      sort_by_date: false,
      sidebarData: {},
      resId: '',
      selected: [],
      campaigns: [],
      section_options: [],
      selected_section: {label:'Filter by section', value: -1},
      searchedProducts: [],
      searchString: '',
      pageCount: 0,
      itemCount: 10
    }
  },
  watch: {
    searchString () {
      this.searchProducts()
    },
    sort_by_date () {
      this.$store.commit('api/SET_ORDER_BY', this.sort_by_date)
    }
  },
  computed: {
    max_page () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const max_page = Math.floor(array.length / this.itemCount)
      return max_page
    },
    pageArray () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const page_array = []
      let i = 0
      const max_page = Math.floor(array.length / this.itemCount)
      const kalan = array.length % this.itemCount
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      if (kalan > 0) {
        page_array.push(max_page + 1)
      }
      return page_array
    },
    displayList () {
      let array = JSON.parse(JSON.stringify(this.displayListSource))
      if (this.sort_by_date) {
        array = array.sort((a, b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.created_date) - new Date(a.created_date)
        })
      }
      return array.splice(this.pageCount * this.itemCount, this.itemCount)
    },
    displayListSource () {
      return this.searchedProducts.length > 0 ? this.searchedProducts : this.contents
    },
    contents () {
      return this.campaigns
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  },
  mounted () {
    this.getEventList()
  },
  methods: {
    editData (content) {
      this.popupData = content
      this.specialPopup = true
    },
    deleteData (id) {
      this.$vs.loading()
      const payload = {
        id
      }
      this.$store.dispatch('api/removeEvent', payload).then(() => {
        this.getEventList()
        this.$vs.loading.close()
      }).catch(err => {
        this.$vs.loading.close()
        console.error(err)
      })
    },
    confirmDelete (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure to delete this item?',
        clickNotClose: true,
        accept: this.deleteData,
        parameters: [id],
        acceptText: 'Delete'
      })

    },
    pageUp () {
      if (this.pageCount < this.max_page) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    filterContents (content, query) {
      return content.name.toLowerCase().includes(query.toLowerCase()) || content.shortContent.toLowerCase().includes(query.toLowerCase()) || content.longContent.toLowerCase().includes(query.toLowerCase())
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    searchProducts () {
      this.searchedProducts = this.contents.filter((content) => this.filterContents(content, this.searchString))
    },
    getEventList () {

      this.$vs.loading()

      const payload = {
        page:'1',
        limit:'0'
      }

      this.$store.dispatch('api/restaurantSales', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.campaigns = response.data.data
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    showPopup () {
      this.specialPopup = true
    },
    popupEnded () {
      this.specialPopup = false
      this.popupData = null
      this.getEventList()
    }
  }
}
</script>

<style lang="scss">

</style>
